import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ReactComponent as FolderIcon } from './../folder-icon.svg';
import { ReactComponent as MessageIcon } from './../message-icon.svg';
import { ReactComponent as AddToTeam } from './../add-freelancer-to-team.svg';
import { ReactComponent as AddToOtherTeam } from './../add-freelancer-to-other-team.svg';
import { ReactComponent as HiredIcon } from './../../PostFooter/complete-icon.svg';
import { ReactComponent as HireArrowIcon } from './../hire-icon.svg';
import { ReactComponent as Loader } from './../loader.svg';
import { ReactComponent as AcceptIcon } from './../../../projectSubCategory/accept-icon.svg';
import { ReactComponent as DeclineIcon } from './../../../projectSubCategory/decline-icon.svg';
import classNames from 'classnames';
import { useSelector } from '../../../../hooks/useSelector';
import { sendGridEmail } from '../../../../firebase/api/mail';
import { getHireToAnswer, getNotHireToAnswer } from '../../../../templates';
import { useAuth } from '../../../../hooks/useAuth';
import { updatePost } from '../../../../firebase/api/post';
import { useDispatch } from 'react-redux';
import { postStatuses } from '../../Post';
import { useActions } from '../../../../hooks/useActions';

const answersState = {
    unselected: 'UNSELECTED',
    picked: 'PICKED',
    hired: 'HIRED',
};

const ReviewedProposal = ({
    review,
    data,
    loading,
    handleOpenPortfolioPopup,
    handleOpenAddToTeamPopup,
    color,
    pickedFreelancers,
    handleChangePickedFreelancers,
}) => {
    const answerState = useMemo(
        () =>
            data.assignTo?.find(
                assignedFreelancer => assignedFreelancer.uid === review.publisherUid
            )
                ? answersState.hired
                : pickedFreelancers.find(freelancerId => freelancerId === review.publisherUid)
                ? answersState.picked
                : answersState.unselected,
        [pickedFreelancers, data, review]
    );

    const allUserTeams = useSelector(state => state.invitePeople.allUserTeams);

    const isDisabled = review.response === 'decline';

    const buttonHireClassName = classNames({
        'proposal__hire-button': true,
        'proposal__hire-button-rejected':
            isDisabled ||
            (data.assignTo !== null &&
                !data.assignTo.find(
                    assignedFreelancer => assignedFreelancer.uid === review.publisherUid
                )),
        'proposal__hire-button-hired': data.assignTo?.find(
            assignedFreelancer => assignedFreelancer.uid === review.publisherUid
        ),
    });

    const style = {
        backgroundColor: !loading ? color : '#BDBFC3',
        cursor: 'pointer',
    };

    const handleTogglePickFreelancer = useCallback(
        () => handleChangePickedFreelancers(review.publisherUid),
        [handleChangePickedFreelancers, review]
    );

    const handleOpenPortfolio = useCallback(
        () => review.portfolioData && handleOpenPortfolioPopup(review.portfolioData),
        [review, handleOpenPortfolioPopup]
    );

    const handleOpenAddToTeam = useCallback(() => {
        review.publisherFirstName && handleOpenAddToTeamPopup(review.publisherEmail);
    }, [review, handleOpenAddToTeamPopup]);

    const portfolioBtnClass = classNames({
        'config-response-btn': true,
        'is-active': !!review.portfolioData,
    });

    const emailBtnClass = classNames({
        'config-response-btn': true,
        'is-active': !!review.publisherEmail,
    });

    const isUserAssignedToTeam = useMemo(
        () => allUserTeams.find(team => team.invitedUsers.includes(review.publisherEmail)),
        [allUserTeams, review]
    );

    const addToTeamClass = classNames({
        'add-to-team-btn': true,
        'add-to-other-team-btn': isUserAssignedToTeam,
        'is-active': !!review.publisherFirstName && !!allUserTeams.length,
    });

    const submitBtnContent = useMemo(() => {
        switch (answerState) {
            case answersState.unselected:
                return (
                    <>
                        <span>Select</span>
                        <HireArrowIcon />
                    </>
                );
            case answersState.picked:
                return (
                    <>
                        <span>Selected</span>
                        {/* <HireArrowIcon /> */}
                    </>
                );
            case answersState.hired:
                return (
                    <>
                        <HiredIcon />
                        <span>Hired</span>
                    </>
                );
        }
    }, [answerState]);

    return (
        <li className="post__proposal">
            <div className="proposal__response-icon-wrap">
                {review.response === 'accept' ? <AcceptIcon /> : <DeclineIcon />}
            </div>
            <div className="proposal__response-freelancer-info">
                {review?.publisherFullName?.trim().length ? (
                    <>
                        <span className="freelancer-name">
                            {!data.assignTo?.find(
                                assignedFreelancer => assignedFreelancer.uid === review.publisherUid
                            )
                                ? review?.publisherFullName
                                : review.publisherFirstName}
                        </span>
                        <div className="hired-info-wrapper">
                            <span className="freelancer-post">{review?.publisherPosition}</span>
                        </div>
                    </>
                ) : (
                    <span className="freelancer-name">{review.publisherEmail}</span>
                )}
            </div>
            <div className="config-response-btns-wrap">
                {/* <ShareIcon /> */}
                <a href={`mailto:${review.publisherEmail}`}>
                    <MessageIcon className={emailBtnClass} />
                </a>
                <FolderIcon onClick={handleOpenPortfolio} className={portfolioBtnClass} />
                {isUserAssignedToTeam ? (
                    <AddToOtherTeam onClick={handleOpenAddToTeam} className={addToTeamClass} />
                ) : (
                    <AddToTeam onClick={handleOpenAddToTeam} className={addToTeamClass} />
                )}
            </div>
            <div className="proposal__right-side-group">
                <button
                    style={!isDisabled && data.assignTo === null ? style : null}
                    className={buttonHireClassName}
                    onClick={handleTogglePickFreelancer}
                    disabled={isDisabled || loading || !!data.assignTo}
                >
                    {submitBtnContent}
                </button>
            </div>
        </li>
    );
};

export default ReviewedProposal;
